import { useMemo, useState } from 'react';
import { trimAndLowerString } from '../../string';

/*
 * @param allData - массив объектов, поиск по которым будет осуществлен
 * @param propertyToCompare - ключ объекта, значение по которому будет использоваться для дальнейшего сравнения
 */
export const useFilteredDataWithSearch = <T>(allData: T[], propertyToCompare: keyof T) => {
    const [searchText, setSearchText] = useState('');

    const { filteredItems, isSearchTextStrictExactSomeComparedValue } = useMemo(
        () =>
            allData.reduce(
                (
                    result: {
                        filteredItems: T[];
                        isSearchTextStrictExactSomeComparedValue: boolean;
                    },
                    item
                ) => {
                    const valueToCompare = trimAndLowerString(String(item[propertyToCompare]));
                    const searchTextToCompare = trimAndLowerString(searchText);

                    if (valueToCompare.includes(searchTextToCompare)) {
                        result.filteredItems.push(item);

                        if (valueToCompare === searchTextToCompare) {
                            result.isSearchTextStrictExactSomeComparedValue = true;
                        }
                    }

                    return result;
                },
                {
                    filteredItems: [],
                    isSearchTextStrictExactSomeComparedValue: false,
                }
            ),
        [allData, searchText, propertyToCompare]
    );

    return {
        // Возможные к показу объекты, с учетом строки поиска (буквально то, что показывается/из чего можно выбирать)
        filteredItems,

        // Устанавливает поисковый текст, введенный пользователем
        setSearchText,

        // Содержимое поискового текста, введенного пользователем
        searchText,

        // Совпадение хотя бы одного объекта с текстом, введенным пользователем
        isSearchTextStrictExactSomeComparedValue,
    };
};
